module.exports = __webpack_public_path__ + "static/img/7.accd8f1f.png";